import React from "react";
import { Reveal } from "./useReveal";

const steps = [
  {
    n: "01",
    title: "Play a game",
    desc: "Sit down at a Hong Kong‑rules table against three AI opponents, any time.",
  },
  {
    n: "02",
    title: "Learn mid‑hand",
    desc: "Tap Hint for live AI guidance, or Analyze My Game after for a full breakdown.",
  },
  {
    n: "03",
    title: "Level up",
    desc: "Progress through courses, climb the ladder, and connect with the community.",
  },
];

const StepGlyph = ({ n }) => (
  <svg
    viewBox="0 0 80 110"
    width="72"
    height="100"
    aria-hidden="true"
    className="flex-shrink-0"
  >
    <rect x="2" y="4" width="76" height="104" rx="8" fill="#2E5C44" />
    <rect x="3" y="2" width="74" height="104" rx="8" fill="#F5F0E8" stroke="#3D7A5A" strokeWidth="1.5" />
    <text
      x="40"
      y="60"
      textAnchor="middle"
      dominantBaseline="central"
      fontFamily="DM Sans"
      fontWeight="900"
      fontSize="30"
      fill="#1A1A1A"
      letterSpacing="-1"
    >
      {n}
    </text>
    <rect x="20" y="82" width="40" height="2" fill="#C0392B" />
  </svg>
);

const HowItWorks = () => {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="bg-[#F5F0E8] py-20 md:py-32 border-t border-[#E5DFD3] relative overflow-hidden"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-14 md:mb-20">
          <p className="text-[11px] md:text-xs uppercase tracking-[0.25em] text-[#3D7A5A] mb-4">
            How It Works
          </p>
          <h2
            data-testid="how-headline"
            className="text-3xl sm:text-4xl md:text-[48px] leading-[1.05] tracking-tight text-[#1A1A1A]"
          >
            <span className="font-black">Three steps</span>{" "}
            <span className="font-light">from your first deal to fluent play.</span>
          </h2>
        </div>

        <div className="relative">
          {/* Desktop horizontal dashed connector */}
          <div
            aria-hidden="true"
            className="hidden md:block absolute left-[10%] right-[10%] top-[58px] h-[2px] dash-jade"
          />

          <div className="grid md:grid-cols-3 gap-10 md:gap-8 relative">
            {steps.map((s, i) => (
              <Reveal
                key={s.n}
                delay={i * 120}
                className="relative flex md:flex-col items-start md:items-start gap-5 md:gap-6"
              >
                {/* Mobile vertical dashed connector */}
                {i < steps.length - 1 && (
                  <div
                    aria-hidden="true"
                    className="md:hidden absolute left-[35px] top-[108px] bottom-[-40px] w-[2px] dash-jade-v"
                  />
                )}
                <div
                  data-testid={`step-${s.n}`}
                  className="flex md:flex-col items-start gap-5 md:gap-6"
                >
                  <StepGlyph n={s.n} />
                  <div className="flex-1">
                    <h3 className="text-xl md:text-2xl tracking-tight text-[#1A1A1A] leading-tight">
                      <span className="font-black">{s.title}</span>
                    </h3>
                    <p className="mt-2 md:mt-3 text-[15px] md:text-base text-[#3a3a38] leading-relaxed max-w-xs">
                      {s.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
